export default "__VITE_ASSET__B77Iw82___"